export enum DashboardTypes {
  GET_DASHBOARD_ORG = '@dashboard/GET_DASHBOARD_ORG',
  GET_DASHBOARD_ORG_SUCCESS = '@dashboard/GET_DASHBOARD_ORG_SUCCESS',
  GET_DASHBOARD_ORG_FAILED = '@dashboard/GET_DASHBOARD_ORG_FAILED',
}
